import { IVariable } from "../../interfaces/IVariable";
import { createTheme, Theme } from "@mui/material/styles";
import { getlocalStorageIdHotsite } from "../../util/LocalStorage";

let idHotsiteLocalStorage = getlocalStorageIdHotsite();

export const variables: IVariable = {
  IdHotsite: idHotsiteLocalStorage > 0 ? idHotsiteLocalStorage : 1,
  Loja: "Tiger",
  UserStorage: "CiINnMVNzkCy/lgR7P99ow==",
  UserToken: "6FjnZBgSzk+39GkfiWu3LQ==",
  UrlApi: "https://dev-ecommerce-lvc-api.primecase.com.br/api",
  UrlLoja:"https://prd-ecommerce-tgr-web.primecase.com.br",
  UrlServiceHost: "https://dev2-pri-sgc-api.primecase.com.br/",
  SecurityKey: "",
  OrgId: "",
  ProviderMerchantId: ""
};

export const template: Theme = createTheme({
  palette: {
    primary: {
      main: "#0c71ff",
      light: "#86B8FF",
      //lighter: "#ece6f7",
      dark: "#08264d",
    },
    secondary: {
      main: "#355c88",
    },
    error: {
      main: "#a91c1c",
    },
    text: {
      primary: "#222",
      //light: "#fff",
    },
    warning: {
      main: "#ff9800",
    },
    // white: {
    //   main: "#fff",
    // },
  },

  typography: {
    subtitle1: {
      fontSize: 12,
    },
    body1: {
      fontSize: 14,
    },
  },
});
